import { AtlBrowserStorageSession } from '@atlassian/browser-storage-controls';
import { fg } from '@atlassian/jira-feature-gating';

const SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
const SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';

// New editor success flag
const updateShowNewEditorSucccessFlag = (value: boolean) => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		// @browser-storage setter
		AtlBrowserStorageSession.setItem(SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString()).catch(
			() => undefined,
		);
	} else {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		sessionStorage.setItem(SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
	}
};

export const getShouldShowNewEditorSucccessFlag = (): boolean =>
	fg('jfp-vulcan-browser-storage-migration')
		? Boolean(AtlBrowserStorageSession.getItem(SHOW_NEW_EDITOR_SUCCESS_FLAG))
		: // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
			Boolean(sessionStorage.getItem(SHOW_NEW_EDITOR_SUCCESS_FLAG));

export const setShowNewEditorSuccessFlag = (): void => {
	updateShowNewEditorSucccessFlag(true);
};

export const clearShowNewEditorSucccessFlag = (): void => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		AtlBrowserStorageSession.removeItem(SHOW_NEW_EDITOR_SUCCESS_FLAG);
	} else {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		sessionStorage.removeItem(SHOW_NEW_EDITOR_SUCCESS_FLAG);
	}
};

// Old editor success flag
const updateShowOldEditorSucccessFlag = (value: boolean) => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		// @browser-storage setter
		AtlBrowserStorageSession.setItem(SHOW_OLD_EDITOR_ERROR_FLAG, value.toString()).catch(
			() => undefined,
		);
	} else {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		sessionStorage.setItem(SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
	}
};

export const getShouldShowOldEditorSucccessFlag = (): boolean =>
	fg('jfp-vulcan-browser-storage-migration')
		? Boolean(AtlBrowserStorageSession.getItem(SHOW_OLD_EDITOR_ERROR_FLAG))
		: // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
			Boolean(sessionStorage.getItem(SHOW_OLD_EDITOR_ERROR_FLAG));

export const clearShowOldEditorSucccessFlag = (): void => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		AtlBrowserStorageSession.removeItem(SHOW_OLD_EDITOR_ERROR_FLAG);
	} else {
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		sessionStorage.removeItem(SHOW_OLD_EDITOR_ERROR_FLAG);
	}
};

export const setShowOldEditorSuccessFlag = (): void => {
	updateShowOldEditorSucccessFlag(true);
};
